import React, { FC } from 'react';
import 'antd/dist/antd.min.css';
import './alert.scss';
import WarningIcon from '@svg/warning.svg?react';

type AlertProps = {
    header?: React.ReactNode;
    message?: React.ReactNode;
    isLight?: boolean;
    isError?: boolean;
};

const Alert: FC<AlertProps> = ({ header, message, isLight, isError }) => {
    return <div className={`alert-component ${isLight ? 'light' : ''} ${isError ? 'error' : ''}`}>
        <div className={'alert-icon'}>
            <WarningIcon />
        </div>
        <div className={'alert-content'}>
            {!!header && <div className={'alert-header'}>{header}</div>}
            {!!message && <div className={'alert-message'}>{message}</div>}
        </div>
    </div>;
};

export default Alert;
